import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function FireMasterIllustration({
  achievementId,
  variant = 'blaze',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3367">
      <div className="relative w-full h-full bg-gradient-to-b from-red-900 to-stone-900 overflow-hidden" data-id="element-3368">
        {/* Background: Volcano and Smoke */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3369">
          {/* Smoke clouds */}
          <circle cx="60" cy="40" r="30" fill="#44403C" fillOpacity="0.6" filter="blur(4px)" data-id="element-3370" />
          <circle cx="140" cy="30" r="40" fill="#292524" fillOpacity="0.7" filter="blur(6px)" data-id="element-3371" />
          <circle cx="100" cy="60" r="35" fill="#57534E" fillOpacity="0.5" filter="blur(5px)" data-id="element-3372" />

          {/* Embers */}
          <circle cx="50" cy="80" r="2" fill="#FDE047" data-id="element-3373" />
          <circle cx="150" cy="100" r="1.5" fill="#F97316" data-id="element-3374" />
          <circle cx="120" cy="50" r="2.5" fill="#EF4444" data-id="element-3375" />
          <circle cx="80" cy="120" r="1" fill="#FDE047" data-id="element-3376" />
        </svg>

        {/* Background: Volcano Ground */}
        <svg className="absolute bottom-0 left-0 w-full h-[40%] z-0" viewBox="0 0 200 80" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-3377">
          <path d="M-20 80 L60 20 L140 20 L220 80 Z" fill="#1C1917" data-id="element-3378" />
          {/* Lava flows */}
          <path d="M70 20 Q80 50 60 80 L80 80 Q90 50 85 20 Z" fill="#EA580C" data-id="element-3379" />
          <path d="M120 20 Q110 40 130 80 L150 80 Q130 40 135 20 Z" fill="#DC2626" data-id="element-3380" />
          <path d="M75 20 Q80 50 65 80 L75 80 Q85 50 80 20 Z" fill="#FDE047" data-id="element-3381" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[10%]" data-id="element-3382">
          <div className="w-[70%] h-[70%] flex items-center justify-center" data-id="element-3383">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'celebrating' : 'thinking'} variant={variant} accessory="doubleFlameCrown" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3384" />
          </div>
        </div>

        {/* Foreground: Extra Lava/Heat */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3385">
            <path d="M0 200 L40 160 L60 200 Z" fill="#1C1917" data-id="element-3386" />
            <path d="M160 200 L180 150 L200 200 Z" fill="#292524" data-id="element-3387" />
            <circle cx="30" cy="180" r="4" fill="#F97316" data-id="element-3388" />
            <circle cx="180" cy="170" r="3" fill="#EF4444" data-id="element-3389" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}